const PageTitle = ({ title }: { title: string }) => {
  return (
    <h1 className="font-Qilka mt-16 text-center text-3xl text-[#231F1E] md:text-[56px]">
      {title}
    </h1>
  );
};

export default PageTitle;
